import { Checkbox } from 'antd'

import { formatCharacteristicValue } from '../Filters.utils'
import generalCn from '../GeneralFiltersStyles.module.scss'
import HighlightText from '../HighlightText/HighlightText'
import cn from './FilterCheckboxList.module.scss'

export type FilterCheckboxListItem = {
  key: string
  label: string
  count?: number
  checked: boolean
}

type FilterCheckboxListProps = {
  items: FilterCheckboxListItem[]
  searchValue: string
  searchPlaceholder: string
  onSearchChange: (value: string) => void
  onToggle: (key: string) => void
  highlightQuery?: string
}

function FilterCheckboxList({
  items,
  searchValue,
  searchPlaceholder,
  onSearchChange,
  onToggle,
  highlightQuery = '',
}: FilterCheckboxListProps) {
  return (
    <div className={generalCn.collapseItemContent}>
      <div className={generalCn.searchBar}>
        <input
          value={searchValue}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={searchPlaceholder}
        />
      </div>
      <div className={cn.list}>
        {items.map((item) => (
          <div
            className={
              item.count === 0
                ? [cn.listItem, cn.listItemDisabled].join(' ')
                : cn.listItem
            }
            key={item.key}
          >
            <div className={cn.checkboxContainer}>
              <Checkbox
                onChange={() => onToggle(item.key)}
                checked={item.checked}
              />
            </div>
            <div className={cn.text}>
              <span>
                <HighlightText
                  text={formatCharacteristicValue(item.label)}
                  query={highlightQuery}
                />
              </span>
              <span>{item.count !== undefined ? `(${item.count})` : ''}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default FilterCheckboxList
